import React, { useContext } from 'react';

import styled from '@emotion/styled';

import { colors } from '../../global';
import { CoreContext } from '../../providers';
import { media } from '../../services/media';

/**
 * This component wraps its children with a `Popup overlay` which allows user
 * to close the popup by "clicking outside of the popup".
 */
export const PopupOverlay: React.FC = ({ children }) => {
    const { closePopup } = useContext(CoreContext);

    /**
     * Hides the popup if user clicks on popup's overlay
     */
    const handleOverlayClick = (
        event: React.MouseEvent<HTMLDivElement, MouseEvent>,
    ) => {
        event.nativeEvent.stopImmediatePropagation();
        event.stopPropagation();

        if (event.target === event.currentTarget) {
            closePopup();
        }
    };

    return (
        <Wrapper
            onClick={handleOverlayClick}
            role="button"
            tabIndex={0}
            data-test="popup-overlay"
        >
            {children}
        </Wrapper>
    );
};

const Wrapper = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    z-index: 15;

    /* ${media.min('lg')} {
        padding: 100px 0;
    } */

    &:before {
        content: '';
        display: block;
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: ${colors.bonJour};
        opacity: 0.75;
    }
`;
